<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">        
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
        <div id="upload-sku">
          <div class="modal-header">
          </div>
          <div class="select-cart">
          </div>

          <mat-tab-group class="mat-tab-labels" (selectedTabChange)="myTabSelectedTabChange($event)">
            <mat-tab label="Import Bulk Orders">
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="upload-text" role="tabpanel"
                  aria-labelledby="pills-home-tab">
                  <br>
                  <br>
                  <div class="upload-content">
                    <p>
                      <b>INSTRUCTIONS:</b>
                      <a class="download-sample" (click)="downloadInstructionFile()"> Download </a>Detailed Instructions.
                    </p>
                    <p>
                      <b>GUIDELINES:</b>
                      <a class="download-sample" (click)="downloadSampleFile()"> Download </a>a sample file that you can
                      populate CSP order details and upload.
                    </p>
                    <p>
                      <b>WARNING:</b>
                      <a>
                        <i>
                          This bulk order creation system does not automatically identify duplicate subscriptions.  There may be valid reasons for requesting multiple subscriptions for the same item.  <b>The responsibility for any duplicate subscriptions created lies solely with the user.</b>  Please carefully review existing subscriptions before placing a bulk order.
                        </i>
                     </a>
                    </p>
                    <label>
                      <b class="dd-bond">
                        Select a File to Upload Bulk Order:
                      </b>
                    </label>
                    <label id="drag-box" (drop)="drop($event)" (dragover)="allowDrop($event)">
                      Choose File or Drag And Drop<input type='file' class="file-display"
                        (change)="onSelectFile($event)">
                    </label>
                    <button [disabled]="disableUpload" [ngbTooltip]="tooltipUpload" [placement]="'bottom'"  id="btnUploadExcel" class="button button-red" style="width: 15%; margin: 0 10px"
                      *ngIf="fileName">
                      Import Orders<input class="file-display" (click)="onImportBulkOrders()">
                    </button>
                    <p *ngIf="fileName">
                      <b class="dd-bond">
                        {{ fileName }}
                      </b>
                    </p>
                  </div>
                </div>


                <div class="my-4" *ngIf="resultTableDataSrc?.length">
                  <div class="upload-content">
                    <p>
                      <a>
                        Please check the status of each tenant to ensure it has been validated successfully.<br />
                      </a>
                    </p>
                  </div>
                  <div>
                    <button name="CREATEALL" class="button button-red button-round" style="margin-left: 750px;"
                      (click)="actionCreateRemoveAll($event.target.name)"
                      [disabled]="!currentUserModel?.hasAdminAccess || !currentUserModel?.hasPurchaseAccess"
                      [matTooltip]="tooltipUpload"
                    >
                      &nbsp;Create All&nbsp;
                    </button>
                    <button name="REMOVEALL" [disabled]="!currentUserModel?.hasAdminAccess || !currentUserModel?.hasPurchaseAccess"
                    [matTooltip]="tooltipUpload" class="button button-red button-round" style="float: right;"
                      (click)="actionCreateRemoveAll($event.target.name)">
                      &nbsp;Remove All&nbsp;
                    </button>
                  </div>
                  <br />
                  <br />
                  <table mat-table [dataSource]="resultTableDataSrc">
                    <ng-container matColumnDef="tenantDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="28%" class="align-left"
                        class="table-column">TENANT DESCRIPTION</th>
                        <td class="align-center" mat-cell *matCellDef="let element" width="28%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.tenantName
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="stockCode">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                        class="table-column">STOCK CODE</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.stockCode
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="offerDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="20%" class="align-left"
                        class="table-column">OFFER DESCRIPTION</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="20%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div style="white-space: nowrap;
                        width: 120px;overflow: hidden;text-overflow: ellipsis;"
                          matTooltip="{{element.offerDescription}}">
                          {{element.offerDescription}}
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="quantity">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column">QTY</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.quantity
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="coterm">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column"></th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div *ngIf ="element.coTermMonthly == 'TRUE'"  matTooltip="CO-TERM CALENDAR MONTH ENABLED">
                          <img src="../images/site-icons/events-red.svg">
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column">STATUS</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%"
                        style="padding-left: 1%; padding-right: 1%; position: relative;vertical-align: middle;">
                        {{element.status}}
                        <mat-icon *ngIf="element.status == 'Error'" matSuffix class="editmpnidicon align-top"
                          placement="bottom" matTooltip="{{element.errorMesage}}">
                          info</mat-icon>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                        mat-header-cell *matHeaderCellDef width="15%">ACTION</th>
                      <td mat-cell *matCellDef="let element" class="align-left"
                        style="padding-left: 1%; padding-right: 1%;padding-bottom: 1%;padding-top: 1%;"
                        class="center-button">
                        <button name="CREATE" *ngIf="element.status == 'Validated'"
                          class="button button-red button-round" style="margin-top: 2px;"
                          (click)="actionCreateRemoveRetry(element.rowId,$event.target.name)"
                          [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                          [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                          matTooltip="Requires Purchasing Permissions"
                        >
                          &nbsp;Create Now&nbsp;
                        </button>
                        <br />                      
                        <button name="REMOVE"
                          *ngIf="element.status == 'Pending Validation' || element.status == 'Validated' || element.status == 'Error' "
                          class="button button-red button-round" style="margin-top: 2px;"
                          (click)="actionCreateRemoveRetry(element.rowId,$event.target.name)">
                          &nbsp;Remove&nbsp;
                        </button>
                        <br />                       
                        <button name="RETRY" *ngIf="element.status == 'Error'" class="button button-red button-round"
                          style="margin-top: 2px;" (click)="actionCreateRemoveRetry(element.rowId,$event.target.name)">
                          &nbsp;Retry&nbsp;
                        </button>
                        <br />
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>
                <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
              </div>
            </mat-tab>
            <mat-tab label="In-Process">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4" *ngIf="resultTableDataSrc?.length">
                  <table mat-table [dataSource]="resultTableDataSrc">
                    <ng-container matColumnDef="tenantDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="30%" class="align-left"
                        class="table-column">TENANT DESCRIPTION</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="30%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.tenantName
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="stockCode">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                        class="table-column">STOCK CODE</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.stockCode
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="offerDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="20%" class="align-left"
                        class="table-column">OFFER DESCRIPTION</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="20%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div style="white-space: nowrap;
                        width: 120px;overflow: hidden;text-overflow: ellipsis;"
                          matTooltip="{{element.offerDescription}}">
                          {{element.offerDescription}}
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="quantity">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column">QTY</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.quantity
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="coterm">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column"></th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div *ngIf ="element.coTermMonthly == 'TRUE'"  matTooltip="CO-TERM CALENDAR MONTH ENABLED">
                          <img src="../../images/coterm-image.png">
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="10%" class="align-left"
                        class="table-column">STATUS</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="10%"
                        style="padding-left: 0%;
                        padding-right: 15%;
                        position: relative;
                        vertical-align: middle;
                        white-space: nowrap;">
                        {{element.status}}
                        <mat-icon *ngIf="element.status == 'Error'" matSuffix class="editmpnidicon align-top"
                          placement="bottom" ngbTooltip="{{element.errorMesage}}">
                          info</mat-icon>
                      </td>
                    </ng-container>                    
                    <tr mat-header-row *matHeaderRowDef="inProgressColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: inProgressColumns"></tr>
                  </table>
                </div>
                <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
              </div>
            </mat-tab>
            <mat-tab label="Archive">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4" *ngIf="resultTableDataSrc?.length">
                  <table mat-table [dataSource]="resultTableDataSrc">
                    <ng-container matColumnDef="tenantDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="30%" class="align-left"
                        class="table-column">TENANT DESCRIPTION</th>
                        <td class="align-center" mat-cell *matCellDef="let element" width="28%"  class="align-left"
                        class="tb-row" style="white-space: pre;">                      
                        <a class="link" ngbTooltip="MANAGE TENANT"   placement="bottom" style ="color: #C20047 !important" (click)="navToTenantDetailPage(element.tenantId)"
                        >{{ element.tenantName}}</a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="stockCode">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                        class="table-column">STOCK CODE</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.stockCode
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="offerDescription">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="15%" class="align-left"
                        class="table-column">OFFER DESCRIPTION</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="15%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div style="white-space: nowrap;
                        width: 120px;overflow: hidden;text-overflow: ellipsis;"
                          matTooltip="{{element.offerDescription}}">
                          {{element.offerDescription}}
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="quantity">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column">QTY</th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">{{ element.quantity
                        }}</td>
                    </ng-container>
                    <ng-container matColumnDef="coterm">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column"></th>
                      <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                        class="tb-row" style="white-space: pre;">
                        <div *ngIf ="element.coTermMonthly == 'TRUE'"  matTooltip="CO-TERM CALENDAR MONTH ENABLED">
                          <img src="../../images/coterm-image.png">
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                        class="table-column">STATUS</th>
                        <td class="align-center" mat-cell *matCellDef="let element" width="10%"
                        style="padding-left: 0%;
                        padding-right: 15%;
                        position: relative;
                        vertical-align: middle;
                        white-space: nowrap;">
                        {{element.status}}
                        <mat-icon *ngIf="element.status == 'Error'" matSuffix class="editmpnidicon align-top"
                          placement="bottom" ngbTooltip="{{element.errorMesage}}">
                          info</mat-icon>
                      </td>
                    </ng-container>    
                    <ng-container matColumnDef="manage">
                      <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                        mat-header-cell *matHeaderCellDef width="15%"></th>
                      <td mat-cell *matCellDef="let element" class="align-left"
                        style="padding-left: 1%; padding-right: 1%;padding-bottom: 1%;padding-top: 1%;"
                        class="center-button">
                        <button name="Manage" 
                          class="button button-red button-round" style="margin-top: 2px;"
                          (click)="navtoToManageSubscription(element.tenantId, element.subscriptionId)">
                          &nbsp;Manage&nbsp;
                        </button>                        
                      </td>
                    </ng-container>                
                    <tr mat-header-row *matHeaderRowDef="archiveColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: archiveColumns"></tr>
                  </table>
                </div>
                <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>